import api from "../../utils/ApiConfig";

export const fetchClosedDays = async () => {
  const response = await api.get("/bo/closed-days");
  return response.data;
};

export const addClosedDay = async (data) => {
  const response = await api.post("/bo/closed-days", data);
  return response.data;
};

export const deleteClosedDay = async (id) => {
  const response = await api.delete(`/bo/closed-days/${id}`);
  return response.data;
};
